import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";

export default function Faq() {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="max-w-4xl mx-auto px-6 lg:px-10 py-24 md:py-32">
      <Reveal>
        <ChapterTag num="07" label={t("ch_faq")} />
        <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight">{t("faq_title")}</h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-4" data-testid="faq-accordion">
          {t("faq").map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="glass rounded-2xl border border-white/10 px-6 overflow-hidden" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display font-bold text-base md:text-lg text-start hover:text-gold hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-sm md:text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
